import { render, staticRenderFns } from "./ModalHistoricoProtocolos.vue?vue&type=template&id=43e0e93c&scoped=true"
import script from "./ModalHistoricoProtocolos.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoProtocolos.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoProtocolos.vue?vue&type=style&index=0&id=43e0e93c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e0e93c",
  null
  
)

export default component.exports